import React, { useContext, useState } from "react";
import ApiContext from "services/ApiContext";
import ShopContext from "services/ShopContext";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { Button, Form, Label } from "reactstrap";

function UpdateStatus(props) {
  const { rID, showModal, setShowModal, refetch } = props;
  const shopID = useContext(ShopContext).selctShopID.ID;
  const Axios = useContext(ApiContext);
  const [selectedOption, setSelectedOption] = useState("");

  // Handle option selection
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };
  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();

    // Send the selected option value to the API endpoint using axios
    Axios.put(`/shop/${shopID}/RequestApproval/${rID}`, {
      Status: selectedOption,
      ShipBackFeesPayment: true,
    })
      .then((response) => {
        setShowModal({
          ...showModal,
          open: !showModal.open,
        });
        // Handle the response from the API
        toast.success(response.data.MESSAGE);
        refetch();
      })
      .catch((error) => {
        // Handle error
        toast.error(error.response.data.MESSAGE);
      });
  };

  return (
    <div>
      <Form onSubmit={handleSubmit}>
        <div className="text-center">
          <Label>Select Status:</Label>
          <select
            value={selectedOption}
            onChange={handleOptionChange}
            className="ml-2 mb-5"
            style={{ width: "50%", height: "100%" }}
          >
            <option value="">Status</option>
            <option value="Approved">Review Approved</option>
            <option value="Rejected">Review Rejected</option>
          </select>
          <Button type="submit" className=" ml-5 btn btn-primary">
            Update
          </Button>
        </div>
      </Form>
    </div>
  );
}
UpdateStatus.propTypes = {
  rID: PropTypes.string.isRequired,
  setShowModal: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
};
export default UpdateStatus;
